export const ApplicationBrand = {
    brandName: 'VE Pharma Sales Portal'
};

export const MenuItems = {
    "applicationItem": {
        "data": [
            {
                parentID: 1,
                item: [
                    {
                        itemTitle: "Sales Report (Salesforce)",
                        itemList: [
                            {
                                id: '1',
                                name: "Comparative Sales Performance",
                                icon: "/Images/graph-bar.svg",
                                path: "/dashboards",
                                roleLevel: "0"
                            }
                        ]
                    },
                    {
                        itemTitle: "Product Sales Reports",
                        itemList: [
                           {
                                id: '2',
                                name: "Comparative Product Performance",
                                icon: "/Images/graph-bar.svg",
                                path: "/dashboards",
                                roleLevel: "4"
                            },  
                            {
                                id: '3',
                                name: "Performance by Product Group",
                                icon: "/Images/product.svg",
                                path: "/dashboards",
                                roleLevel: "0"
                            },
                            {
                                id: '4',
                                name: "Comparative Sales",
                                icon: "/Images/desk-customer.svg",
                                path: "/dashboards",
                                roleLevel: "4"
                            }
                            // ,
                            // {
                            //     id: '7',
                            //     name: "Customer Group Product",
                            //     icon: "/Images/product.svg",
                            //     path: "/dashboards",
                            //     roleLevel: "0"
                            // }
                            // ,
                            // {
                            //   id: 'products',
                            //   name: "Product Performance Y o Y",
                            //   icon: "/Images/product.svg",
                            //   roleLevel: "4",
                            //   path: "/data/historical"
                            // }
                        ]
                    },
                    {
                        itemTitle: "Customer Sales Reports",
                        itemList: [
                            // {
                            //     id: '5',
                            //     name: "Growth Performance",
                            //     icon: "/Images/graph-bar.svg",
                            //     path: "/dashboards",
                            //     roleLevel: "0"
                            // },
                            {
                                id: '6',
                                name: "Customer Sales",
                                icon: "/Images/product.svg",
                                path: "/dashboards",
                                roleLevel: "0"
                            },
                        ]
                    },
                    {
                        itemTitle: "Quarterly Sales",
                        itemList: [
                            {
                                id: '8',
                                name: "Salesforce",
                                icon: "/Images/product.svg",
                                path: "/dashboards",
                                roleLevel: "4"
                            },
                             {
                                id: '9',
                                name: "Products",
                                icon: "/Images/product.svg",
                                path: "/dashboards",
                                roleLevel: "4"
                            },
                        ]
                    },
                   
                    {
                        itemTitle: "Special Accounts Sales Reports ",
                        itemList: [
                            {
                                id: '11',
                                name: "Comparative Sales",
                                icon: "/Images/product.svg",
                                path: "/dashboards",
                                roleLevel: "4"
                            },
                             {
                                id: '12',
                                name: "Quarterly Sales",
                                icon: "/Images/product.svg",
                                path: "/dashboards",
                                roleLevel: "4"
                            },
                        ]
                    },
                    {
                         itemTitle: "Quick Views",
                         itemList: [
                            //   {
                            //     id: 'regions',
                            //     name: "Regions",
                            //     icon: "/Images/regions.svg",
                            //     path: "/list",
                            //     roleLevel: "4"
                            // },
                               {
                                 id: 'dms',
                                 name: "District Managers",
                                 icon: "/Images/districts.svg",
                                 path: "/list",
                                 roleLevel: "2"
                               },
                               {
                                 id: 'employees',
                                 name: "Territory Manager",
                                 icon: "/Images/employees.svg",
                                 path: "/list",
                                 roleLevel: "1"
                               },
                            // {
                            //     id: 'c-groups',
                            //     name: "Customer Groups",
                            //     icon: "/Images/desk-customer.svg",
                            //     path: "/list",
                            //     roleLevel: "0"
                            // },
                            //   {
                            //     id: 'p-groups',
                            //     name: "Product Groups",
                            //     icon: "/Images/product-group.svg",
                            //     path: "/list",
                            //     roleLevel: "0"
                            //  },
                                //  {
                                //   id: 'products',
                                //   name: "Products",
                                //   icon: "/Images/product.svg",
                                //   roleLevel: "4",
                                //   path: "/list"
                                //  }
                          ]
                    },  
                ]
            }
        ]
    }
};

export const ApplicationItems = {
    "applications": [
      {
        name: "Sales Analytics",
        icon: "/Images/graph-bar.svg",
        modules: [
          {
            id: 1,
            name: "Dashboard",
            icon: "/Images/dashboard.svg",
            roleLevel: "0",
            path: "/dashboards",
            children: [
              {
                menuHeader: "Sales Reports (Salesforce)"
              },
              {
                id: 1,
                name: "Comparative Sales Performance",
                icon: "/Images/graph-bar.svg",
                roleLevel: "0",
                path: "/dashboards"
              },
              {
                menuHeader: "Product Sales Reports"
              },
              {
                id: 3,
                name: "Comparative Product Performance",
                icon: "/Images/desk-customer.svg",
                roleLevel: "0",
                path: "/dashboards"
              },
              {
                id: 4,
                name: "Performance by Product Group",
                icon: "/Images/desk-customer.svg",
                roleLevel: "0",
                path: "/dashboards"
              },
              {
                id: 5,
                name: "Comparative Sales",
                icon: "/Images/product.svg",
                roleLevel: "0",
                path: "/dashboards"
              },
              // {
              //   id: 'products',
              //   name: "Product Performance Y o Y",
              //   icon: "/Images/product.svg",
              //   roleLevel: "0",
              //   path: "/data/historical"
              // },
              {
                menuHeader: "Customer Sales Reports"
              },
              // {
              //   id: 5,
              //   name: "Growth Performance",
              //   icon: "/Images/desk-customer.svg",
              //   roleLevel: "0",
              //   path: "/dashboards"
              // },
              {
                id: 7,
                name: "Customer Sales",
                icon: "/Images/desk-customer.svg",
                roleLevel: "0",
                path: "/dashboards"
              },

              {
                menuHeader: "Quarterly Sales Report"
              },
              {
                id: 8,
                name: "Salesforces",
                icon: "/Images/desk-customer.svg",
                roleLevel: "0",
                path: "/dashboards"
              },
              {
                id: 9,
                name: "Products",
                icon: "/Images/desk-customer.svg",
                roleLevel: "0",
                path: "/dashboards"
              },

               {
                menuHeader: "Special Accounts Sales Reports"
              },
              {
                id: 11,
                name: "Comparative Sales",
                icon: "/Images/desk-customer.svg",
                roleLevel: "0",
                path: "/dashboards"
              },
              {
                id: 12,
                name: "Quarterly Sales",
                icon: "/Images/desk-customer.svg",
                roleLevel: "0",
                path: "/dashboards"
              },
              {
                menuHeader: "Quick Views",
                roleLevel: "0"
              },
              {
                id: 'regions',
                name: "Regions",
                icon: "/Images/regions.svg",
                roleLevel: "4",
                path: "/list"
              },
              {
                id: 'dms',
                name: "District Managers",
                icon: "/Images/districts.svg",
                roleLevel: "2",
                path: "/list"
              },
              {
                id: 'employees',
                name: "Territory",
                icon: "/Images/employees.svg",
                roleLevel: "1",
                path: "/list"
              },
              // {
              //   id: 'c-groups',
              //   name: "Customer Groups",
              //   icon: "/Images/desk-customer.svg",
              //   roleLevel: "0",
              //   path: "/list"
              // },
              {
                id: 'p-groups',
                name: "Product Groups",
                icon: "/Images/product-group.svg",
                roleLevel: "0",
                path: "/list"
              },
              // {
              //   id: 'products',
              //   name: "Products",
              //   icon: "/Images/product.svg",
              //   roleLevel: "4",
              //   path: "/list"
              // }
            ]
          }
        ]
      }
    ]
  }